import { useEffect, useState } from 'react';
import {
  sablonUrunGrupListesi, sablonUrunGrupOlustur, sablonUrunGrupGuncelle, sablonUrunGrupSil,
  sablonUrunListesi, sablonUrunOlustur, sablonUrunGuncelle, sablonUrunSil, sablonUrunGorselYukle, dosyaUrl,
  sablonBannerYukle, sablonLogoYukle, sablonYonetimGuncelle
} from '../services/api';

// Admin'in "Şablonlar" bölümünden bir şablonu içerik olarak düzenlemesi için bağımsız editör.
// Şablonlar artık İşletme tablosunun İÇİNDE değil, tamamen ayrı SABLON* tablolarında yaşıyor —
// bu yüzden burada X-Isletme-Id header'ı taklit etmeye gerek yok, doğrudan /admin-sablon/{id}/...
// uçları çağrılıyor. Kullanıcı talebi: 2026-07-27 (önceki tasarımda bir işletme silinirken şablon
// verisinin yanlışlıkla silinme riski vardı — bu yeniden yazım o riski ortadan kaldırıyor).
// Masalar/Garson sekmeleri bilerek KALDIRILDI — ama isim/banner/logo (Genel/Görünüm) geri eklendi,
// şablon için bunlar zorunlu (kullanıcı talebi: 2026-07-27).
export default function SablonDuzenle({ sablon, onKapat, onAdGuncellendi }) {
  // --- İsim ---
  const [ad, setAd] = useState(sablon.ad);
  const [adKaydediliyor, setAdKaydediliyor] = useState(false);
  const [adMesaj, setAdMesaj] = useState('');
  const adKaydet = (e) => {
    e.preventDefault();
    setAdKaydediliyor(true); setAdMesaj('');
    sablonYonetimGuncelle(sablon.id, ad)
      .then(() => { setAdMesaj('Kaydedildi.'); onAdGuncellendi && onAdGuncellendi(sablon.id, ad); })
      .catch(() => setAdMesaj('Kaydedilemedi.'))
      .finally(() => setAdKaydediliyor(false));
  };

  // --- Banner / Logo ---
  const [bannerUrl, setBannerUrl] = useState(sablon.bannerUrl || '');
  const [logoUrl, setLogoUrl] = useState(sablon.logoUrl || '');
  const [bannerYukleniyor, setBannerYukleniyor] = useState(false);
  const [logoYukleniyor, setLogoYukleniyor] = useState(false);

  const bannerSecildi = (e) => {
    const dosya = e.target.files[0];
    if (!dosya) return;
    setBannerYukleniyor(true);
    sablonBannerYukle(sablon.id, dosya).then((res) => setBannerUrl(res.data.url)).catch(() => {}).finally(() => setBannerYukleniyor(false));
  };
  const logoSecildi = (e) => {
    const dosya = e.target.files[0];
    if (!dosya) return;
    setLogoYukleniyor(true);
    sablonLogoYukle(sablon.id, dosya).then((res) => setLogoUrl(res.data.url)).catch(() => {}).finally(() => setLogoYukleniyor(false));
  };

  // --- Ürün Grupları / Ürünler ---
  const [gruplar, setGruplar] = useState([]);
  const [urunler, setUrunler] = useState([]);
  const [icerikYukleniyor, setIcerikYukleniyor] = useState(true);
  const [hata, setHata] = useState('');

  const icerigiYenile = () => {
    setIcerikYukleniyor(true);
    Promise.all([sablonUrunGrupListesi(sablon.id), sablonUrunListesi(sablon.id)])
      .then(([g, u]) => { setGruplar(g.data); setUrunler(u.data); })
      .catch((err) => setHata(err.response?.data?.hata || 'Veriler alınamadı.'))
      .finally(() => setIcerikYukleniyor(false));
  };

  useEffect(() => {
    icerigiYenile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Grup modal
  const [grupModalAcik, setGrupModalAcik] = useState(false);
  const [grupDuzenlenen, setGrupDuzenlenen] = useState(null);
  const [grupAd, setGrupAd] = useState('');
  const [grupSira, setGrupSira] = useState(0);
  const [kaydediliyor, setKaydediliyor] = useState(false);
  const [modalHata, setModalHata] = useState('');

  const grupModaliAc = (grup) => {
    setGrupDuzenlenen(grup || null);
    setGrupAd(grup ? grup.ad : '');
    setGrupSira(grup ? grup.sira : gruplar.length);
    setModalHata('');
    setGrupModalAcik(true);
  };
  const grupKaydet = (e) => {
    e.preventDefault();
    setModalHata(''); setKaydediliyor(true);
    const dto = { ad: grupAd, sira: Number(grupSira) };
    const istek = grupDuzenlenen ? sablonUrunGrupGuncelle(sablon.id, grupDuzenlenen.id, dto) : sablonUrunGrupOlustur(sablon.id, dto);
    istek.then(() => { setGrupModalAcik(false); icerigiYenile(); }).catch((err) => setModalHata(err.response?.data?.hata || 'Kaydedilemedi.')).finally(() => setKaydediliyor(false));
  };
  const grupSilOnayla = (grup) => {
    if (!window.confirm(`"${grup.ad}" grubunu ve içindeki tüm ürünleri kaldırmak istediğinize emin misiniz?`)) return;
    sablonUrunGrupSil(sablon.id, grup.id).then(icerigiYenile).catch((err) => setHata(err.response?.data?.hata || 'Silinemedi.'));
  };

  // Ürün modal
  const [urunModalAcik, setUrunModalAcik] = useState(false);
  const [urunDuzenlenen, setUrunDuzenlenen] = useState(null);
  const [urunGrupId, setUrunGrupId] = useState('');
  const [urunAd, setUrunAd] = useState('');
  const [urunFiyat, setUrunFiyat] = useState('');
  const [urunAciklama, setUrunAciklama] = useState('');
  const [urunGorselUrl, setUrunGorselUrl] = useState('');
  const [gorselYukleniyor, setGorselYukleniyor] = useState(false);

  const urunModaliAc = (urun, varsayilanGrupId) => {
    const duzenlemeModu = !!(urun && urun.id);
    setUrunDuzenlenen(duzenlemeModu ? urun : null);
    setUrunGrupId(duzenlemeModu ? urun.grupId : (varsayilanGrupId || gruplar[0]?.id || ''));
    setUrunAd(duzenlemeModu ? urun.ad : '');
    setUrunFiyat(duzenlemeModu ? urun.fiyat : '');
    setUrunAciklama(duzenlemeModu ? urun.aciklama || '' : '');
    setUrunGorselUrl(duzenlemeModu ? urun.gorselUrl || '' : '');
    setModalHata('');
    setUrunModalAcik(true);
  };
  const gorselSecildi = (e) => {
    const dosya = e.target.files[0];
    if (!dosya) return;
    setGorselYukleniyor(true);
    sablonUrunGorselYukle(sablon.id, dosya).then((res) => setUrunGorselUrl(res.data.url)).catch((err) => setModalHata(err.response?.data?.hata || 'Görsel yüklenemedi.')).finally(() => setGorselYukleniyor(false));
  };
  const urunKaydet = (e) => {
    e.preventDefault();
    if (!urunGrupId) { setModalHata('Lütfen bir ürün grubu seçiniz.'); return; }
    setModalHata(''); setKaydediliyor(true);
    const dto = {
      grupId: Number(urunGrupId), ad: urunAd, fiyat: Number(urunFiyat) || 0,
      aciklama: urunAciklama, gorselUrl: urunGorselUrl, sira: urunDuzenlenen ? urunDuzenlenen.sira : urunler.length
    };
    const istek = urunDuzenlenen ? sablonUrunGuncelle(sablon.id, urunDuzenlenen.id, dto) : sablonUrunOlustur(sablon.id, dto);
    istek.then(() => { setUrunModalAcik(false); icerigiYenile(); }).catch((err) => setModalHata(err.response?.data?.hata || 'Kaydedilemedi.')).finally(() => setKaydediliyor(false));
  };
  const urunSilOnayla = (urun) => {
    if (!window.confirm(`"${urun.ad}" ürününü kaldırmak istediğinize emin misiniz?`)) return;
    sablonUrunSil(sablon.id, urun.id).then(icerigiYenile).catch((err) => setHata(err.response?.data?.hata || 'Silinemedi.'));
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', zIndex: 1200, overflowY: 'auto', padding: '30px 16px' }}>
      <div className="kart" style={{ width: '100%', maxWidth: 900 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <h3 style={{ margin: 0, color: '#1e2a3a' }}>Şablonu Düzenle — {sablon.ad}</h3>
          <button type="button" onClick={onKapat} className="btn btn-koyu">Kapat</button>
        </div>

        {hata && <div className="hata-kutu">{hata}</div>}

        <div className="kart" style={{ marginBottom: 20 }}>
          <h3 style={{ marginTop: 0, color: '#1e2a3a' }}>Şablon Adı</h3>
          <form onSubmit={adKaydet} style={{ display: 'flex', gap: 10, alignItems: 'flex-end', flexWrap: 'wrap' }}>
            <div>
              <label style={{ fontSize: 12, fontWeight: 600, color: '#6b7684', display: 'block', marginBottom: 6 }}>İsim</label>
              <input value={ad} onChange={(e) => setAd(e.target.value)} required />
            </div>
            <button type="submit" disabled={adKaydediliyor} className="btn btn-vurgu">{adKaydediliyor ? 'Kaydediliyor...' : 'Kaydet'}</button>
          </form>
          {adMesaj && <div style={{ marginTop: 8, fontSize: 13, color: '#1e5c30', fontWeight: 600 }}>{adMesaj}</div>}
        </div>

        <div className="kart" style={{ marginBottom: 20 }}>
          <h3 style={{ marginTop: 0, color: '#1e2a3a' }}>Görünüm Ayarları</h3>
          <div style={{ display: 'flex', gap: 24, flexWrap: 'wrap' }}>
            <div style={{ flex: 1, minWidth: 260 }}>
              <label style={{ fontSize: 12, fontWeight: 600, color: '#6b7684', display: 'block', marginBottom: 6 }}>Banner</label>
              {bannerUrl && <img src={dosyaUrl(bannerUrl)} alt="Banner önizleme" style={{ width: '100%', height: 100, objectFit: 'cover', borderRadius: 8, marginBottom: 8 }} />}
              <input type="file" accept="image/png,image/jpeg,image/webp" onChange={bannerSecildi} />
              {bannerYukleniyor && <div style={{ fontSize: 12, color: '#6b7684', marginTop: 4 }}>Yükleniyor...</div>}
            </div>
            <div style={{ width: 160 }}>
              <label style={{ fontSize: 12, fontWeight: 600, color: '#6b7684', display: 'block', marginBottom: 6 }}>Logo</label>
              {logoUrl && <img src={dosyaUrl(logoUrl)} alt="Logo önizleme" style={{ width: 60, height: 60, objectFit: 'cover', borderRadius: 8, marginBottom: 8 }} />}
              <input type="file" accept="image/png,image/jpeg,image/webp" onChange={logoSecildi} />
              {logoYukleniyor && <div style={{ fontSize: 12, color: '#6b7684', marginTop: 4 }}>Yükleniyor...</div>}
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <h3 style={{ margin: 0, color: '#1e2a3a' }}>Ürün Grupları ve Ürünler</h3>
          <button onClick={() => grupModaliAc(null)} className="btn btn-vurgu">+ Yeni Ürün Grubu</button>
        </div>

        {icerikYukleniyor ? (
          <div>Yükleniyor...</div>
        ) : gruplar.length === 0 ? (
          <div className="kart" style={{ color: '#6b7684', marginBottom: 24 }}>Henüz ürün grubu eklenmedi.</div>
        ) : (
          gruplar.map((grup) => (
            <div key={grup.id} className="kart" style={{ marginBottom: 16 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                <div style={{ fontWeight: 700, color: '#e8600c' }}>{grup.ad}</div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <button onClick={() => urunModaliAc(null, grup.id)} className="btn btn-vurgu" style={{ padding: '6px 12px', fontSize: 12 }}>+ Ürün Ekle</button>
                  <button onClick={() => grupModaliAc(grup)} className="btn btn-koyu" style={{ padding: '6px 12px', fontSize: 12 }}>Düzenle</button>
                  <button onClick={() => grupSilOnayla(grup)} className="btn btn-kirmizi" style={{ padding: '6px 12px', fontSize: 12 }}>Sil</button>
                </div>
              </div>
              {urunler.filter((u) => u.grupId === grup.id).length === 0 ? (
                <div style={{ color: '#6b7684', fontSize: 13 }}>Bu grupta henüz ürün yok.</div>
              ) : (
                urunler.filter((u) => u.grupId === grup.id).map((urun) => (
                  <div key={urun.id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '8px 0', borderTop: '1px solid #f0f0f0' }}>
                    {urun.gorselUrl && <img src={dosyaUrl(urun.gorselUrl)} alt={urun.ad} style={{ width: 44, height: 44, borderRadius: 6, objectFit: 'cover' }} />}
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: 600 }}>{urun.ad} — {Number(urun.fiyat).toFixed(2)} ₺</div>
                      {urun.aciklama && <div style={{ fontSize: 12, color: '#6b7684' }}>{urun.aciklama}</div>}
                    </div>
                    <button onClick={() => urunModaliAc(urun)} className="btn btn-koyu" style={{ padding: '5px 10px', fontSize: 12 }}>Düzenle</button>
                    <button onClick={() => urunSilOnayla(urun)} className="btn btn-kirmizi" style={{ padding: '5px 10px', fontSize: 12 }}>Sil</button>
                  </div>
                ))
              )}
            </div>
          ))
        )}

        {grupModalAcik && (
          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1300 }}>
            <form onSubmit={grupKaydet} className="kart" style={{ width: 360 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
                <h3 style={{ margin: 0, color: '#1e2a3a' }}>{grupDuzenlenen ? 'Grubu Düzenle' : 'Yeni Ürün Grubu'}</h3>
                <button type="button" onClick={() => setGrupModalAcik(false)} className="btn btn-koyu">✕</button>
              </div>
              {modalHata && <div className="hata-kutu">{modalHata}</div>}
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                <div>
                  <label style={{ fontSize: 12, fontWeight: 600, color: '#6b7684', display: 'block', marginBottom: 6 }}>Grup Adı</label>
                  <input value={grupAd} onChange={(e) => setGrupAd(e.target.value)} required />
                </div>
                <div>
                  <label style={{ fontSize: 12, fontWeight: 600, color: '#6b7684', display: 'block', marginBottom: 6 }}>Sıra</label>
                  <input type="number" value={grupSira} onChange={(e) => setGrupSira(e.target.value)} />
                </div>
                <button type="submit" disabled={kaydediliyor} className="btn btn-vurgu">{kaydediliyor ? 'Kaydediliyor...' : 'Kaydet'}</button>
              </div>
            </form>
          </div>
        )}

        {urunModalAcik && (
          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1300 }}>
            <form onSubmit={urunKaydet} className="kart" style={{ width: 400 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
                <h3 style={{ margin: 0, color: '#1e2a3a' }}>{urunDuzenlenen ? 'Ürünü Düzenle' : 'Yeni Ürün'}</h3>
                <button type="button" onClick={() => setUrunModalAcik(false)} className="btn btn-koyu">✕</button>
              </div>
              {modalHata && <div className="hata-kutu">{modalHata}</div>}
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                <div>
                  <label style={{ fontSize: 12, fontWeight: 600, color: '#6b7684', display: 'block', marginBottom: 6 }}>Ürün Grubu</label>
                  <select value={urunGrupId} onChange={(e) => setUrunGrupId(e.target.value)} required>
                    <option value="">Seçiniz</option>
                    {gruplar.map((g) => <option key={g.id} value={g.id}>{g.ad}</option>)}
                  </select>
                </div>
                <div>
                  <label style={{ fontSize: 12, fontWeight: 600, color: '#6b7684', display: 'block', marginBottom: 6 }}>Ürün Adı</label>
                  <input value={urunAd} onChange={(e) => setUrunAd(e.target.value)} required />
                </div>
                <div>
                  <label style={{ fontSize: 12, fontWeight: 600, color: '#6b7684', display: 'block', marginBottom: 6 }}>Fiyat</label>
                  <input type="number" step="0.01" value={urunFiyat} onChange={(e) => setUrunFiyat(e.target.value)} required />
                </div>
                <div>
                  <label style={{ fontSize: 12, fontWeight: 600, color: '#6b7684', display: 'block', marginBottom: 6 }}>Açıklama</label>
                  <input value={urunAciklama} onChange={(e) => setUrunAciklama(e.target.value)} />
                </div>
                <div>
                  <label style={{ fontSize: 12, fontWeight: 600, color: '#6b7684', display: 'block', marginBottom: 6 }}>Görsel</label>
                  {urunGorselUrl && <img src={dosyaUrl(urunGorselUrl)} alt="Önizleme" style={{ width: 60, height: 60, objectFit: 'cover', borderRadius: 6, marginBottom: 6 }} />}
                  <input type="file" accept="image/png,image/jpeg,image/webp" onChange={gorselSecildi} />
                  {gorselYukleniyor && <div style={{ fontSize: 12, color: '#6b7684', marginTop: 4 }}>Yükleniyor...</div>}
                </div>
                <button type="submit" disabled={kaydediliyor} className="btn btn-vurgu">{kaydediliyor ? 'Kaydediliyor...' : 'Kaydet'}</button>
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
  );
}
